import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_DOMAIN } from "config";
import { Img, Heading } from "components";

export default function ProPayPage() {
  const { search } = useLocation();
  const { pid } = useParams();
  const nav = useNavigate();
  const timerRef = useRef(null);

  const [statusText, setStatusText] = useState("בודקים סטטוס תשלום...");

  const url = useMemo(() => {
    const q = new URLSearchParams(search);
    const u = q.get("u");
    return u ? decodeURIComponent(u) : "";
  }, [search]);

  useEffect(() => {
    if (!pid) return;

    const paymentId = Number(pid);
    if (!paymentId) return;

    const check = async () => {
      try {
        // ✅ אימות אמיתי מול PayMe דרך השרת
        const res = await axios.get(`${API_DOMAIN}/billing/verifyPaymePayment/${paymentId}`);
        const st = res?.data?.data?.status;

        if (st === "paid") {
          clearInterval(timerRef.current);
          nav("/pro/success", { replace: true });
          return;
        }

        if (st === "failed") {
          clearInterval(timerRef.current);
          nav("/pro/cancel", { replace: true });
          return;
        }

        setStatusText("מחכה לאישור תשלום...");
      } catch (e) {
        setStatusText("ממתינה... (יתכן שעדיין לא עודכן)");
      }
    };

    check();
    timerRef.current = setInterval(check, 2000);
    return () => clearInterval(timerRef.current);
  }, [pid, nav]);

  if (!pid) return <div style={{ padding: 20 }}>חסר מזהה תשלום</div>;

  return (
             <div className="car-catalog-dealer flex bg-blue_gray-50 p-8 sm:p-4 " style={{paddingTop: '1.2rem'}}>
                <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: '2%' }}>
                  <div className="flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">
                    <header className="flex flex-col items-start gap-3">
                      <div className="absolute top-0 left-0 h-8 w-[20%] bg-[rgb(239,240,241)] flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                        <div className="flex w-full justify-center gap-1">
                          <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                            <span className="text-gray-900_04">&nbsp;</span>
                            <span className="font-heebo font-medium text-gray-600">pro</span>
                          </Heading>
                          <Img src="/images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                        </div>
                        <div className="flex w-full items-center justify-center">
                          <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                            שדרוג
                          </Heading>
                          <Img src="/images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                        </div>
                      </div>
                      <div className="flex items-center justify-between gap-5 mt-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
                  
                        <div className="flex justify-center gap-4 xs-flex-row-reverse md:flex-row">
    
                        </div>
                        <div className="flex gap-3">
                          <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                            שדרוג מנוי     🚀                 </Heading>
                        </div>
                      </div>
                    </header>
    <div className="tfpro-page">
      <div className="tfpro-card">
        <h2>תשלום לשדרוג PRO</h2>

        {url ? (
          <iframe
            src={url}
            title="PayMe"
            style={{ width: "100%", height: "90vh", border: "none" }}
            allow="payment *"
          />
        ) : (
          <div>{statusText}</div>
        )}


      </div>
    </div>
                  </div>
                </div>
              </div>

  );
}
